const initialState = [];
//
export default function cm0006(state = initialState, action) {
  switch (action.type) {
    case 'SET_CM0006':
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case 'SET_CM0006_ERROR':
      return state;
    default:
      return state;
  }
}
